import { useEffect, useState } from 'react'
import { getTreeDetails } from '@fs/zion-tree-groups'

// Fetches tree details once and returns them; exposes error for potential future handling
export function useTreeDetails(treeId) {
  const [treeDetails, setTreeDetails] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    let isCurrent = true
    async function fetchDetails() {
      try {
        const data = await getTreeDetails(treeId)
        if (isCurrent) setTreeDetails(data)
      } catch (err) {
        if (isCurrent) setError(err)
      }
    }
    if (treeId) {
      fetchDetails()
    }
    return () => {
      isCurrent = false
    }
  }, [treeId])

  return { treeDetails, error }
}
